import { getAnonymousStamp } from "../../utils/anonymousStamp";

export const QUERY_FEATURE_FLAGS = "QUERY_FEATURE_FLAGS";

export const getFeatureFlagsQueryKey = (personId?: string) => [
  QUERY_FEATURE_FLAGS,
  getAnonymousStamp(),
  personId
];
